
import { createSlice } from '@reduxjs/toolkit';
import { addEmployeeAction, blockMemberAction, editEmployeeAction, employeePaginatedAction, fetchTeamMembers, ModerationMemeberAction } from '../actions/TeamsActions';

export interface TeamMember {
    _id: string;
    email: string;
    first_name: string;
    last_name: string;
    status: string;
}

// Define the state
interface TeamsState {
    members: TeamMember[];
    membersPagination: {
        currentPage: number;
        totalPages: number;
        totalItems: number;
        itemsPerPage: number;
    }
    loading: boolean;
    error: string | null;
    employeeDataLoading: boolean;
}

// Initial state
const initialState: TeamsState = {
    members: [],
    membersPagination: {
        currentPage: 1,
        totalPages: 1,
        totalItems: 1,
        itemsPerPage: 10,
    },
    loading: false,
    error: null,
    employeeDataLoading: false
};



// Create the slice
const TeamsSlice = createSlice({
    name: 'teams',
    initialState,
    reducers: {

    },
    extraReducers: builder => {
        builder
            // Fetch Team Members
            .addCase(fetchTeamMembers.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTeamMembers.fulfilled, (state, action) => {
                state.loading = false;
                state.members = action.payload.data;
            })
            .addCase(fetchTeamMembers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // fetch employee paginated
            .addCase(employeePaginatedAction.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(employeePaginatedAction.fulfilled, (state, action) => {
                state.loading = false;
                state.members = action.payload.data;
                state.membersPagination = action.payload.pagination;
            })
            .addCase(employeePaginatedAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            .addCase(addEmployeeAction.pending, state => {
                state.employeeDataLoading = true;
            })
            .addCase(addEmployeeAction.fulfilled, (state, action) => {
                state.employeeDataLoading = false;
            })
            .addCase(addEmployeeAction.rejected, (state, action) => {
                state.employeeDataLoading = false;
            })

            .addCase(editEmployeeAction.pending, state => {
                state.employeeDataLoading = true;
            })
            .addCase(editEmployeeAction.fulfilled, (state, action) => {
                state.employeeDataLoading = false;
            })
            .addCase(editEmployeeAction.rejected, (state, action) => {
                state.employeeDataLoading = false;
            })

            // Block Member
            .addCase(blockMemberAction.pending, state => {
                state.loading = true;
            })
            .addCase(blockMemberAction.fulfilled, (state, action) => {
                state.loading = false;

                const updatedMember = action.payload;

                state.members = state.members?.map(member =>
                    member._id === updatedMember._id
                        ? { ...member, status: updatedMember.status }
                        : member
                );
            })
            .addCase(blockMemberAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            //Moderation
            .addCase(ModerationMemeberAction.pending, state => {
                state.loading = true;
            })
            .addCase(ModerationMemeberAction.fulfilled, (state, action) => {
                state.loading = false;


                state.members = state.members?.map(member =>
                    member._id === action.payload._id
                        ? { ...member, moderation: action.payload.moderation }
                        : member
                );
            })
            .addCase(ModerationMemeberAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });


    }

});



export default TeamsSlice.reducer;
